export const textFieldProps = {
    variant: 'outlined',
    fullWidth: true,
    style: { marginBottom: 10}
}